<template>
  <div class="hp-product-picker">
    <label class="d-block mb-1">محصولات انتخاب‌شده ({{ value.length }})</label>
    <ul class="list-group mb-2">
      <li v-for="(pid, i) in value" :key="pid" class="list-group-item d-flex align-items-center py-1">
        <img v-if="info(pid).image" :src="info(pid).image" class="hp-pimg ml-2" alt="">
        <span class="flex-grow-1 small">{{ info(pid).name || ('محصول #' + pid) }}</span>
        <CButton size="sm" variant="ghost" color="secondary" :disabled="i === 0" @click="move(i, -1)">▲</CButton>
        <CButton size="sm" variant="ghost" color="secondary" :disabled="i === value.length - 1" @click="move(i, 1)">▼</CButton>
        <CButton size="sm" variant="ghost" color="danger" @click="remove(i)">✕</CButton>
      </li>
      <li v-if="!value.length" class="list-group-item text-muted small">محصولی انتخاب نشده است</li>
    </ul>
    <CInput v-model="q" size="sm" placeholder="جستجوی محصول (نام یا کد)..." @input="onSearch" />
    <ul v-if="results.length" class="list-group hp-results">
      <li v-for="p in results" :key="p.id" class="list-group-item list-group-item-action d-flex align-items-center py-1" @click="add(p)">
        <img v-if="p.image" :src="p.image" class="hp-pimg ml-2" alt="">
        <span class="flex-grow-1 small">{{ p.name }}</span>
        <span v-if="value.indexOf(p.id) !== -1" class="badge badge-success">انتخاب‌شده</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { searchProducts } from './hpApi'

const nameCache = {}

export default {
  name: 'HpProductPicker',
  props: { value: { type: Array, default: function () { return [] } } },
  data() {
    return { q: '', results: [], timer: null, tick: 0 }
  },
  mounted() {
    // resolve names of already selected products (one broad request)
    if (this.value.some((id) => !nameCache[id])) this.fetch('', 500, true)
  },
  methods: {
    info(id) {
      // eslint-disable-next-line no-unused-expressions
      this.tick
      return nameCache[id] || {}
    },
    onSearch() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.q.trim().length < 2) { this.results = []; return }
        this.fetch(this.q.trim(), 20, false)
      }, 350)
    },
    fetch(q, perPage, silent) {
      searchProducts(q, perPage).then((res) => {
        const items = ((res.data && res.data.items) || []).map((p) => ({
          id: p.id,
          name: p.name,
          image: p.gallery && p.gallery[0] ? p.gallery[0].image : ''
        }))
        items.forEach((p) => { nameCache[p.id] = p })
        this.tick++
        if (!silent) this.results = items
      }).catch(() => {})
    },
    emit(list) {
      this.$emit('input', list)
    },
    add(p) {
      if (this.value.indexOf(p.id) !== -1) return
      this.emit(this.value.concat([p.id]))
    },
    remove(i) {
      const l = this.value.slice()
      l.splice(i, 1)
      this.emit(l)
    },
    move(i, d) {
      const l = this.value.slice()
      const t = l[i]
      l[i] = l[i + d]
      l[i + d] = t
      this.emit(l)
    }
  }
}
</script>

<style scoped>
.hp-pimg { width: 32px; height: 32px; object-fit: cover; border-radius: 4px; }
.hp-results { max-height: 260px; overflow-y: auto; cursor: pointer; }
</style>
